<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'app',
  created() {
    console.log('store', this.$store)
  },
  methods: {
    Refresh() {
      // todo   https://www.cnblogs.com/gaoht/p/15512474.html
      // let screenWidth = document.documentElement.clientWidth
      // if(screenWidth < 650 && !this._isMobile) {
      //   Vue.prototype._isMobile = true  // 要放在store里
      //   this.$router.go(0)
      //   // location.reload()
      // }
      // if(screenWidth > 1200 && this._isMobile) {
      //   Vue.prototype._isMobile = false
      //   this.$router.go(0)
      // }
    }
  },
  mounted() {
    //窗口尺寸改变
    // window.addEventListener("resize", () => this.Refresh())
  },
  destroyed() {
    // 销毁
    // window.removeEventListener("resize", this.Refresh());
  },
}
</script>

<style lang="scss">
@import './assets/css/reset.css';
@import './assets/css/element-variables.scss';
@import '~@/assets/css/theme.scss';
// @import '~@/assets/css-mobile/common.scss';
</style>

